<template>
  <section class="income">
    <h3 class="income-title">
      <span class="line"></span>
      <span class="text">收入FAQ</span>
      <span class="line"></span>
    </h3>

    <dl class="qa">
      <dt class="ask">收入系统正在研发中，敬请期待。</dt>
      <dd class="answer"></dd>
    </dl>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 收入 faq
    name: 'income'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "income.styl";
</style>



// WEBPACK FOOTER //
// src/views/income/income.vue